import React              from 'react';
import PropTypes          from 'prop-types';
import { Button, Popup }  from 'semantic-ui-react';
import { Link }           from 'react-router-dom';

// -----------------------------------------------------
// Settings
// -----------------------------------------------------

const title = 'Edit this record.';

// -----------------------------------------------------
// Component Definition
// -----------------------------------------------------

const EditButton = ({ formId, recordId }) => {
  const href =
    `/organization/internal_form_responses/${formId}/records/${recordId}/edit`;

  const Btn = <Button icon='pencil'
                      basic
                      color='blue'
                      as={ Link }
                      to={ href } />;

  return (
    <Popup  trigger={ Btn }
            content={ title }
            position='top center' />
  );
};

// -----------------------------------------------------
// PropTypes
// -----------------------------------------------------

EditButton.propTypes = {
  formId:   PropTypes.number.isRequired,
  recordId: PropTypes.number.isRequired
};

// -----------------------------------------------------
// Exports
// -----------------------------------------------------

export default EditButton;
